// Elyra - Cart Functions
 
var ELYRA_VARIANTS = {
  waist: {
    'Μαυρο': {'S':'53968219177299','M':'53968219210067','L':'53968219242835','XL':'53968219275603','XXL':'53968219308371','3XL':'53968219341139'},
    'Μπεζ':  {'S':'53968219373907','M':'53968219406675','L':'53968219439443','XL':'53968219472211','XXL':'53968219504979','3XL':'53968219537747'}
  },
  band: {'Μπλε':'53968227762515','Ροζ':'53968227795283','Μωβ':'53968227828051'},
  nad: '53968295231827',
  duo: {
    'Μαυρο':{'S':{'Μπλε':'53968240116051','Ροζ':'53968240148819','Μωβ':'53968240181587'},'M':{'Μπλε':'53968240214355','Ροζ':'53968240247123','Μωβ':'53968240279891'},'L':{'Μπλε':'53968240312659','Ροζ':'53968240345427','Μωβ':'53968240378195'},'XL':{'Μπλε':'53968240410963','Ροζ':'53968240443731','Μωβ':'53968240476499'},'XXL':{'Μπλε':'53968240509267','Ροζ':'53968240542035','Μωβ':'53968240574803'},'3XL':{'Μπλε':'53968240607571','Ροζ':'53968240640339','Μωβ':'53968240673107'}},
    'Μπεζ':{'S':{'Μπλε':'53968241197395','Ροζ':'53968241230163','Μωβ':'53968241262931'},'M':{'Μπλε':'53968240705875','Ροζ':'53968240738643','Μωβ':'53968240771411'},'L':{'Μπλε':'53968240804179','Ροζ':'53968240836947','Μωβ':'53968240869715'},'XL':{'Μπλε':'53968240902483','Ροζ':'53968240935251','Μωβ':'53968240968019'},'XXL':{'Μπλε':'53968241000787','Ροζ':'53968241033555','Μωβ':'53968241066323'},'3XL':{'Μπλε':'53968241099091','Ροζ':'53968241131859','Μωβ':'53968241164627'}}
  },
  kit: {'Μπλε':'53968296706387','Ροζ':'53968296739155','Μωβ':'53968296771923'},
  nad_waist: {
    'Μαυρο':{'S':'53968291168595','M':'53968291201363','L':'53968291234131','XL':'53968291266899','XXL':'53968291299667','3XL':'53968291332435'},
    'Μπεζ':{'S':'53968291365203','M':'53968291397971','L':'53968291430739','XL':'53968291463507','XXL':'53968291496275','3XL':'53968291529043'}
  }
};
 
// Toast notification
window.showToast = function(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function() { t.classList.remove('show'); }, 3000);
};
 
// Cart drawer toggle
window.toggleCart = function() {
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) { window.location.href = '/cart'; return; }
  drawer.classList.toggle('open');
  if (drawer.classList.contains('open')) { loadCartDrawer(); }
};
 
function loadCartDrawer() {
  fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
    var countEl = document.getElementById('cart-count');
    if (countEl) countEl.textContent = cart.item_count;
    var listEl = document.getElementById('cart-items-list');
    var emptyEl = document.getElementById('cart-empty');
    var footerEl = document.getElementById('cart-footer');
    var totalEl = document.getElementById('cart-total-price');
    if (!listEl) return;
    if (cart.item_count === 0) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      if (footerEl) footerEl.style.display = 'none';
    } else {
      if (emptyEl) emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'block';
      if (totalEl) totalEl.textContent = '€' + (cart.total_price / 100).toFixed(2).replace('.', ',');
      listEl.innerHTML = cart.items.map(function(item) {
        return '<div class="cart-item"><div class="cart-item-info"><div class="cart-item-name">' + item.product_title + '</div><div class="cart-item-var">' + (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') + '</div><div class="cart-item-price">€' + (item.price/100).toFixed(2).replace('.',',') + '</div></div></div>';
      }).join('');
    }
  });
}
 
function elyraAddToCart(variantId, onSuccess) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: parseInt(variantId), quantity: 1})
  }).then(function(r){return r.json();}).then(function(item){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var countEl = document.getElementById('cart-count');
      if (countEl) countEl.textContent = cart.item_count;
    });
    if (onSuccess) onSuccess(item);
  }).catch(function(e){ console.error('Cart error:', e); });
}
 
window.addBundleWithOptions = function(name, price, prefix, types) {
  var waistColor = '', waistSize = '', bandColor = '';
  if (types.indexOf('waist') >= 0) {
    var allWaistColors = document.querySelectorAll('[id="'+prefix+'-waist-color"]');
    var wColorEl = null;
    document.querySelectorAll('.offer-cdot').forEach(function(el) {
      if (el.id === prefix+'-waist-color' && el.classList.contains('active')) wColorEl = el;
    });
    var wSizeEl = document.querySelector('#'+prefix+'-waist-size .offer-size-btn.active');
    var errEl = document.getElementById(prefix+'-waist-err');
    if (!wSizeEl) { if(errEl) errEl.classList.add('show'); return; }
    if(errEl) errEl.classList.remove('show');
    waistColor = wColorEl ? wColorEl.dataset.color : 'Μαύρο';
    if (waistColor === 'Μαύρο') waistColor = 'Μαυρο';
    waistSize = wSizeEl.textContent.trim();
  }
  if (types.indexOf('band') >= 0) {
    var bColorEl = null;
    document.querySelectorAll('.offer-cdot').forEach(function(el) {
      if (el.id === prefix+'-band-color' && el.classList.contains('active')) bColorEl = el;
    });
    bandColor = bColorEl ? bColorEl.dataset.color : 'Μπλε';
  }
  var variantId = null;
  if (prefix === 'duo') { try { variantId = ELYRA_VARIANTS.duo[waistColor][waistSize][bandColor]; } catch(e) {} }
  else if (prefix === 'nad') { try { variantId = ELYRA_VARIANTS.nad_waist[waistColor][waistSize]; } catch(e) {} }
  else if (prefix === 'kit') { try { variantId = ELYRA_VARIANTS.kit[bandColor]; } catch(e) {} }
 
  if (variantId) {
    elyraAddToCart(variantId, function() { showToast(name + ' προστέθηκε στο καλάθι! 🛒'); });
  } else {
    var links = {'Sculpt + Flex Duo':'/products/sculpt-flex-duo','Sculpt + NAD+ Care':'/products/sculpt-nad-care','Active Wellness Kit':'/products/active-wellness-kit'};
    if (links[name]) window.location.href = links[name];
  }
};
 
window.addToCart = function(event, name, price, type) {
  if (event && event.stopPropagation) event.stopPropagation();
  var variantId = null;
  if (type === 'waist') {
    var card = document.querySelector('#waist-img') ? document.querySelector('#waist-img').closest('.product-card') : null;
    var colorEl = card ? card.querySelector('.cdot.active') : null;
    var sizeEl = document.querySelector('.size-btn.active');
    if (!sizeEl) { showToast('Επίλεξε μέγεθος!'); return; }
    var bg = colorEl ? colorEl.style.background : '';
    var color = (bg.indexOf('26, 26') >= 0 || bg.indexOf('1A1A18') >= 0 || bg === '#1A1A18') ? 'Μαυρο' : 'Μπεζ';
    try { variantId = ELYRA_VARIANTS.waist[color][sizeEl.textContent.trim()]; } catch(e) {}
  } else if (type === 'band') {
    var bandCard = document.querySelector('#band-img') ? document.querySelector('#band-img').closest('.product-card') : null;
    var bandColorEl = bandCard ? bandCard.querySelector('.cdot.active') : null;
    var bandBg = bandColorEl ? bandColorEl.style.background : '';
    var bandC = (bandBg.indexOf('123') >= 0 || bandBg.indexOf('7BB3D4') >= 0) ? 'Μπλε' : (bandBg.indexOf('244') >= 0 || bandBg.indexOf('F4A7B9') >= 0) ? 'Ροζ' : 'Μωβ';
    variantId = ELYRA_VARIANTS.band[bandC];
  } else if (type === 'nad') {
    variantId = ELYRA_VARIANTS.nad;
  }
  if (variantId) {
    elyraAddToCart(variantId, function() { showToast(name + ' προστέθηκε στο καλάθι! 🛒'); });
  } else {
    var links = {'waist':'/products/sculpt-ζώνη-μέσης','band':'/products/flex-ελαστική-ταινία','nad':'/products/nad-αυτοκόλλητα'};
    if (links[type]) window.location.href = links[type];
  }
};
 
window.addBundle = function(name, price) {
  if (name === 'Elyra Full Pack') {
    var sizeEl = document.querySelector('.bsel-size.active');
    if (!sizeEl) { var errEl = document.getElementById('bsize-err'); if(errEl) errEl.classList.add('show'); return; }
    window.location.href = '/products/elyra-full-pack';
  }
};
 
 
// Course variants
var COURSE_VARIANTS = {
  'month1': '53968327410003',
  'month3': '53968329277779',
  'month12': '53968330195283'
};
 
window.addCourseToCart = function(plan) {
  var variantId = COURSE_VARIANTS[plan];
  if (variantId) {
    elyraAddToCart(variantId, function() {
      var names = {'month1':'Course Μήνας 1','month3':'Course 3 Μήνες','month12':'Course 12 Μήνες'};
      showToast((names[plan] || 'Course') + ' προστέθηκε στο καλάθι! 🛒');
    });
  }
};
 
 
// Unlock popup
var selectedUnlockPlan = null;
 
window.openUnlockPopup = function() {
  var popup = document.getElementById('unlock-popup');
  if (popup) {
    popup.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
};
 
window.closeUnlockPopup = function() {
  var popup = document.getElementById('unlock-popup');
  if (popup) {
    popup.classList.remove('open');
    document.body.style.overflow = '';
  }
};
 
window.selectUnlock = function(el, plan) {
  // Remove selected from all rows
  document.querySelectorAll('.unlock-row').forEach(function(r) {
    r.classList.remove('selected');
  });
  el.classList.add('selected');
  selectedUnlockPlan = plan;
  // Show pay button
  var btn = document.getElementById('unlock-pay-btn');
  if (btn) btn.style.display = 'block';
};
 
window.proceedUnlockPayment = function() {
  if (!selectedUnlockPlan) return;
  
  var courseVariants = {
    'month1': '53968327410003',
    'month3': '53968329277779',
    'month12': '53968330195283'
  };
  
  var productVariants = {
    'waist': null,
    'band': null,
    'nad': '53968295231827'
  };
  
  var variantId = courseVariants[selectedUnlockPlan] || productVariants[selectedUnlockPlan];
  
  if (variantId) {
    closeUnlockPopup();
    elyraAddToCart(variantId, function() {
      showToast('Προστέθηκε στο καλάθι! 🛒');
    });
  } else if (selectedUnlockPlan === 'waist' || selectedUnlockPlan === 'band') {
    closeUnlockPopup();
    window.location.href = selectedUnlockPlan === 'waist' ? '/products/sculpt-ζώνη-μέσης' : '/products/flex-ελαστική-ταινία';
  }
};
 
 
// Add product from course page
window.addCourseProduct = function(type) {
  var variants = {
    'waist': '53968219210067',
    'band': '53968227762515',
    'nad': '53968295231827',
    'fullpack': '53968325050707'
  };
  var names = {
    'waist': 'Sculpt Ζώνη Μέσης',
    'band': 'Flex Ελαστική Ταινία',
    'nad': 'NAD+ Αυτοκόλλητα',
    'fullpack': 'Elyra Full Pack'
  };
  var variantId = variants[type];
  if (variantId) {
    elyraAddToCart(variantId, function() {
      showToast(names[type] + ' προστέθηκε στο καλάθι! 🛒');
    });
  }
};
 
 
// Hamburger menu toggle
window.toggleNav = function() {
  var links = document.querySelector('.nav-links');
  var hamburger = document.getElementById('hamburger');
  if (links) links.classList.toggle('open');
  if (hamburger) hamburger.classList.toggle('open');
};
 
window.closeNav = function() {
  var links = document.querySelector('.nav-links');
  var hamburger = document.getElementById('hamburger');
  if (links) links.classList.remove('open');
  if (hamburger) hamburger.classList.remove('open');
};
 
 
// Email Modal - auto-open on page load
window.openEmailModal = function() {
  var el = document.getElementById('em-step-1');
  if (el) el.style.display = 'block';
  var el2 = document.getElementById('em-step-2');
  if (el2) el2.style.display = 'none';
  var modal = document.getElementById('email-modal');
  if (modal) modal.classList.add('open');
};
 
window.closeEmailModal = function() {
  var modal = document.getElementById('email-modal');
  if (modal) modal.classList.remove('open');
  try { sessionStorage.setItem('elyra_popup_shown', '1'); } catch(e) {}
};
 
window.closeEmailModalOutside = function(e) {
  if (e.target === document.getElementById('email-modal')) closeEmailModal();
};
 
window.handleFreeTrialEmail = function() {
  var email = document.getElementById('user-email');
  if (!email || !email.value || email.value.indexOf('@') < 0) {
    showToast('Παρακαλώ εισάγετε ένα έγκυρο email');
    return;
  }
  var sentEl = document.getElementById('sent-email');
  if (sentEl) sentEl.textContent = email.value;
  document.getElementById('em-step-1').style.display = 'none';
  document.getElementById('em-step-2').style.display = 'block';
  try { localStorage.setItem('elyra_demo_email', email.value); } catch(e) {}
};
 
window.handleSocialLogin = function(provider) {
  closeEmailModal();
  showToast('Ανακατεύθυνση στο ' + provider + '...');
};
 
window.backToStep1 = function() {
  document.getElementById('em-step-1').style.display = 'block';
  document.getElementById('em-step-2').style.display = 'none';
};
 
// Auto-open email modal after 1.5s (only on homepage, once per session)
window.addEventListener('load', function() {
  if (window.location.pathname !== '/' && window.location.pathname !== '') return;
  try { if (sessionStorage.getItem('elyra_popup_shown')) return; } catch(e) {}
  setTimeout(function() {
    openEmailModal();
    try { sessionStorage.setItem('elyra_popup_shown', '1'); } catch(e) {}
  }, 1500);
});
 
 
// Course Unlock Code System
var UNLOCK_MAP = {
  'ELYRA-M1': [1],
  'ELYRA-M2': [1,2],
  'ELYRA-M3': [1,2,3],
  'ELYRA-12': [1,2,3,4,5,6,7,8,9,10,11,12]
};
 
function getUnlockedMonths() {
  try {
    var data = localStorage.getItem('elyra_unlocked');
    return data ? JSON.parse(data) : [];
  } catch(e) { return []; }
}
 
function saveUnlockedMonths(months) {
  try {
    var existing = getUnlockedMonths();
    months.forEach(function(m) {
      if (existing.indexOf(m) < 0) existing.push(m);
    });
    existing.sort(function(a,b){return a-b;});
    localStorage.setItem('elyra_unlocked', JSON.stringify(existing));
    return existing;
  } catch(e) { return months; }
}
 
function applyUnlockedMonths() {
  var unlocked = getUnlockedMonths();
  if (unlocked.length === 0) return;
  
  // Show status
  var statusEl = document.getElementById('unlock-status');
  var statusMonths = document.getElementById('unlock-status-months');
  if (statusEl && statusMonths && unlocked.length > 0) {
    statusEl.style.display = 'block';
    statusMonths.textContent = unlocked.join(', ');
  }
  
  // Unlock each month visually
  unlocked.forEach(function(monthNum) {
    var monthEl = document.getElementById('month-' + monthNum);
    if (monthEl) {
      // Change from locked to unlocked style
      monthEl.classList.remove('month-locked');
      monthEl.classList.add('month-free');
      
      // Update badge
      var badge = monthEl.querySelector('.m-badge-locked');
      if (badge) {
        badge.textContent = 'ΞΕΚΛΕΙΔΩΜΕΝΟ';
        badge.className = 'm-badge-free';
        badge.style.color = '#4CAF50';
        badge.style.borderColor = '#4CAF50';
      }
      
      // Update number color
      var numEl = monthEl.querySelector('.m-num');
      if (numEl) numEl.style.color = '#C8B89A';
      
      // Update title color
      var titleEl = monthEl.querySelector('.m-title');
      if (titleEl) titleEl.style.color = '#FAF8F5';
      
      // Show month body content if it has locked overlay
      var ctaLocked = monthEl.querySelector('.m-cta-locked, .cta-locked');
      if (ctaLocked) ctaLocked.style.display = 'none';
    }
  });
}
 
window.unlockCourse = function() {
  var input = document.getElementById('unlock-code-input');
  var code = input.value.trim().toUpperCase();
  var errorEl = document.getElementById('unlock-error');
  var successEl = document.getElementById('unlock-success');
  var successText = document.getElementById('unlock-success-text');
  
  errorEl.style.display = 'none';
  successEl.style.display = 'none';
  
  if (!code) {
    errorEl.style.display = 'block';
    return;
  }
  
  // Extract prefix (first 8 chars: ELYRA-XX)
  var prefix = code.substring(0, 8);
  var months = UNLOCK_MAP[prefix];
  
  if (months) {
    var all = saveUnlockedMonths(months);
    
    // Show success
    var monthNames = {1:'Μήνας 1',2:'Μήνας 2',3:'Μήνας 3',4:'Μήνας 4',5:'Μήνας 5',6:'Μήνας 6',7:'Μήνας 7',8:'Μήνας 8',9:'Μήνας 9',10:'Μήνας 10',11:'Μήνας 11',12:'Μήνας 12'};
    var names = months.map(function(m) { return monthNames[m]; }).join(', ');
    successText.textContent = '✓ Ξεκλειδώθηκαν: ' + names;
    successEl.style.display = 'block';
    input.style.borderColor = '#4CAF50';
    
    // Apply visual unlock
    applyUnlockedMonths();
    
    if (window.showToast) showToast('Course ξεκλειδώθηκε! 🎉');
  } else {
    errorEl.style.display = 'block';
    input.style.borderColor = '#c44';
  }
};
 
// Apply unlocked months on page load
window.addEventListener('load', function() {
  if (window.location.pathname.indexOf('/pages/course') >= 0) {
    setTimeout(applyUnlockedMonths, 500);
  }
});
 